import { Component } from '@angular/core';

@Component({
    selector: 'save-instruction',
    templateUrl: './save-instruction.component.html'
})
export class SaveInstructionComponent {
    action: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/mappinginstructions/saveinstruction/save-instruction.component.ts